import {
  ControlledDateInput,
  ControlledInput,
} from "components/Card/ControlledInput";
import { Checkbox, MaskedInput } from "components/inputs";
import type {
  Control,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";

import type { LienFormValues } from "../../../LienTypes";

type JudicialReviewSectionProps = {
  control: Control<LienFormValues>;
  getValues: UseFormGetValues<LienFormValues>;
  setValue: UseFormSetValue<LienFormValues>;
  handleFieldChange: (field: string | null, value: unknown) => Promise<void>;
};

const JudicialReviewSection = ({
  control,
  getValues,
  setValue,
  handleFieldChange,
}: JudicialReviewSectionProps) => {
  const hasJudicialReview = getValues("judicial_review") ?? false;

  return (
    <>
      <div className="header-primary flex jc-sb ai-c">
        <div className="text-sm text-gray-500">
          Removal to Federal Dist Court
        </div>
      </div>

      <Checkbox
        name="judicial_review"
        label="Judicial Review"
        checked={getValues("judicial_review")}
        required={false}
        onChange={async (e) => {
          setValue("judicial_review", e.target.checked);
          if (!e.target.checked) {
            setValue("summons_complaint_filed_date", null);
            setValue("summons_complaint_registered_mail_date", null);
            setValue("federal_district_court_appeal_amount", null);
            setValue("federal_district_court_appeal_amount_disputed", null);
            setValue("federal_district_court_appeal_amount_due", null);
            setValue(
              "federal_district_court_appeal_decision_dollar_amount",
              null,
            );
            setValue("federal_district_court_appeal_savings", null);
            await handleFieldChange(null, {
              judicial_review: false,
              summons_complaint_filed_date: null,
              summons_complaint_registered_mail_date: null,
              federal_district_court_appeal_amount: null,
              federal_district_court_appeal_amount_disputed: null,
              federal_district_court_appeal_amount_due: null,
              federal_district_court_appeal_decision_dollar_amount: null,
              federal_district_court_appeal_savings: null,
            });
          } else {
            await handleFieldChange("judicial_review", e.target.checked);
          }
        }}
      />

      {hasJudicialReview && (
        <>
          <ControlledDateInput
            control={control}
            name="summons_complaint_filed_date"
            label="Filed Date"
            errors={{}}
            allowFutureDates={true}
            onSave={(value) =>
              handleFieldChange("summons_complaint_filed_date", value)
            }
          />

          <ControlledDateInput
            control={control}
            name="summons_complaint_registered_mail_date"
            label="Registered Mail Date"
            errors={{}}
            allowFutureDates={true}
            onSave={(value) =>
              handleFieldChange("summons_complaint_registered_mail_date", value)
            }
          />

          <ControlledInput
            control={control}
            name="federal_district_court_appeal_amount"
            label="Federal District Court Appeal Amount"
            errors={{}}
            onSave={(value) =>
              handleFieldChange("federal_district_court_appeal_amount", value)
            }
            componentType={MaskedInput}
            mask="dollar"
          />

          <ControlledInput
            control={control}
            name="federal_district_court_appeal_amount_disputed"
            label="Federal District Court Appeal Amount Disputed"
            errors={{}}
            onSave={(value) =>
              handleFieldChange(
                "federal_district_court_appeal_amount_disputed",
                value,
              )
            }
            componentType={MaskedInput}
            mask="dollar"
            readOnly
          />

          <ControlledInput
            control={control}
            name="federal_district_court_appeal_amount_due"
            label="Federal District Court Appeal Amount Due"
            errors={{}}
            onSave={(value) =>
              handleFieldChange(
                "federal_district_court_appeal_amount_due",
                value,
              )
            }
            componentType={MaskedInput}
            mask="dollar"
            readOnly
          />

          <ControlledInput
            control={control}
            name="federal_district_court_appeal_decision_dollar_amount"
            label="Federal District Court Appeal Decision Dollar Amount"
            errors={{}}
            onSave={(value) =>
              handleFieldChange(
                "federal_district_court_appeal_decision_dollar_amount",
                value,
              )
            }
            componentType={MaskedInput}
            mask="dollar"
          />

          <ControlledInput
            control={control}
            name="federal_district_court_appeal_savings"
            label="Federal District Court Appeal Savings"
            errors={{}}
            onSave={(value) =>
              handleFieldChange("federal_district_court_appeal_savings", value)
            }
            componentType={MaskedInput}
            mask="dollar"
            readOnly
          />
        </>
      )}
    </>
  );
};

export default JudicialReviewSection;
